module.exports = __webpack_public_path__ + "static/media/Taiwan_Beer.2d093e0c.png";